export const Events = {
  MOUSE_KEY_DOWN_CODE: 0,
  ENTER_KEY_CODE: 13
};
